export default __webpack_public_path__ + "static/media/Anubis_1.ebb4ef45.png";